import type {
  CategoriesRecoPlaylist,
  CategoryItem,
  MsCatalogCategoryResponse,
  PlaylistDetails,
} from '../../interfaces/msCatalogCategory';

const sortIdsAsSent = (
  firstIdsList: number[],
  items: Omit<CategoryItem, 'parent' | 'parents' | 'platform'>[],
) =>
  items.sort((a, b) => firstIdsList.indexOf(a.id) - firstIdsList.indexOf(b.id));

const processResponse = (items: CategoryItem[]) =>
  items.map(({ id, level, image, platform }: CategoryItem) => {
    const platformId = Object.keys(platform)[0];

    return {
      id,
      name: platform[platformId].name,
      level,
      image,
      slug: platform[platformId].slug,
    };
  });

export const processCategoriesRecoResponse = (
  firstIdsList: number[][],
  response: MsCatalogCategoryResponse,
  playlistDetails: PlaylistDetails[],
): CategoriesRecoPlaylist[] =>
  playlistDetails.map((details, index) => ({
    title: details.title,
    engineName: details.engineName,
    displayType: details.displayType,
    displayAddToCartButton: details.displayAddToCartButton,
    items: sortIdsAsSent(
      firstIdsList[index],
      processResponse(response.content),
    ),
  }));
